import { render } from "./InviteMemberAgents.vue?vue&type=template&id=1ebfce40&scoped=true"
import script from "./InviteMemberAgents.vue?vue&type=script&lang=js"
export * from "./InviteMemberAgents.vue?vue&type=script&lang=js"

import "./InviteMemberAgents.vue?vue&type=style&index=0&id=1ebfce40&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebfce40"]])

export default __exports__